import React, { useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import "./style.scss";
import Categories from "./Categories";
import Inspirations from "./Inspirations";
import OrderSummery from "./OrderSummery";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import { legSelectionAtom, loaderAtom, modelAtom, preFixAtom, upholsteryAtom, uploadImageAtom } from "../../state";
import { useRecoilState, useRecoilValue } from "recoil";
import StoutInspirations from "./Inspirations/StoutInspirations";
import { checkOriginCondi } from "../../lib/constant";

const Home = (props) => {
    const history = useNavigate();
    const category = props.category;
    const [uploadImage, setUploadImage] = useRecoilState(uploadImageAtom)
    // const modelSrc = useRecoilValue<{ categoryName: string, src: string, loading: number }>(modelAtom);
    const [preFix, setPreFix] = useRecoilState(preFixAtom);
    const loader = useRecoilValue(loaderAtom)
    const getCheckSupport = localStorage.getItem('checkSupport')
    const [upholsteryAtomState, setUpholsteryAtomState] = useRecoilState(upholsteryAtom);
   
    const setCategory = (category) => {
        setUploadImage('')
        setUpholsteryAtomState({ ...upholsteryAtomState, currentPart: category === 'grove' ? ['Inner'] : ['Fabric'] })
        history(`/${category}`)
    }

    const support_format_webp = () => {
        var elem = document.createElement('canvas');

        if (!!(elem.getContext && elem.getContext('2d'))) {
            // was able or not to get WebP representation
            return elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;
        }
        else {
            // very old browser like IE 8, canvas not supported
            return false;
        }
    }

    useEffect(() => {
        fetch("https://apis.polyfoundry.com/prod/check")
            .then((res) => res.text())
            .then((res) => {
                setPreFix(res);
            })
            .catch((err) => console.log(err));
        if (!getCheckSupport) {
            const checkSupport = support_format_webp()
            localStorage.setItem('checkSupport', JSON.stringify(checkSupport))
        }
    }, []);

    return (
        <div className="wrapper" style={{ userSelect: 'none' }}>
            <Header />
            <div className="banner-section section pt-5 pb-5">
                <Categories setCategory={setCategory} category={category} loader={loader} />
            </div>
            <section className="product-info section">
                {checkOriginCondi ?
                    <StoutInspirations category={category} loader={loader} />
                    :
                    <Inspirations category={category} loader={loader} />
                }
            </section>
            <section className="product-summary section">
                <OrderSummery />
            </section>
            <Footer />
        </div>
    );
}


export default Home;